import React from 'react'
import {
  CestaState,
  Product,
  Service,
} from '../../context/reducers/cestaReducer'
import {
  isHighCapacityCarter,
  selectCesta,
} from '../../context/selectors/cestaSelectors'
import { connect } from 'react-redux'
import { IAppState } from '../../context/context'
import { t } from '../../i18n'
import styles from './index.module.scss'

interface Props {
  item: Partial<Product> | Service
  cestaState?: CestaState
  hasHighCapacityCarter: boolean
}
const CarterClaim: React.FC<Props> = ({ hasHighCapacityCarter }) => {
  return hasHighCapacityCarter ? (
    <span className={styles.carter_claim}>{t('carter_claim')}</span>
  ) : null
}

const mapStateToProps = (state: IAppState, ownProps) => ({
  hasHighCapacityCarter: isHighCapacityCarter(
    ownProps.cestaState || selectCesta(state),
    ownProps.item
  ),
})
export default connect(mapStateToProps)(CarterClaim)
